export const CAMPAIGN_WRAPPER = 'campaign-wrapper';
export const HIGHLIGHTS_CAROUSEL_WRAPPER = 'highlights-carousel-wrapper';
export const UPCOMING_CAMPAIGNS_WRAPPER = 'upcoming-campaigns-wrapper';
export const THB_OUTER_WRAPPER = 'thb-wrapper';
export const VOYAGER_BANNER = 'voyagerBanner';
export const trackEvents = {
    closeEventName: 'myLounge_voucher_close',
    showEventName: 'myLounge_voucher_shown',
    redeemEventName: 'myLounge_voucher_cta',
};

export const TERMS_AND_CONDITIONS_HASH = '#terms-and-conditions';
export const TURN_ON_PLUS_HASH = '#turn-on-plus';
export const LATER_HASH = '#later';
export const PLUS_HASH = '#plus';
export const CONTINUE_SHOPPING_HASH = '#continue-shopping';
export const EXPLORE_YOUR_REWARDS_HASH = '#explore-your-rewards';

/**
 * This value is decided by product
 * to ensure that enough campaigns
 * can be shown under the starting today rule
 */
export const MIN_CAMPAIGNS_TO_DISPLAY_NEW_IN = 8;

export const FREE_DELIVERY_COOKIE = 'zl_free_delivery_modal_shown';
export const FREE_DELIVERY_BANNER_COOKIE = 'zl_free_delivery_banner_shown';
export const FREE_DELIVERY_SESSION_COOKIE = 'zl_free_delivery_session_modal_shown';
export const LOYALTY_OPT_IN_ONBOARDING_DIALOG_COOKIE = 'zl_loyalty_opt_in_onboarding_dialog_shown';
export const GRANTED = 'GRANTED';
